import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import {
  TabNavigation,
  Input,
  NextStepButton,
  TextArea,
  InputError,
  Logo
} from "components";
import { UPDATE_INPUT, MOVE_TAB } from "actions";

// {errors.name && <InputError label={props.domain.Strings.tab1CompanyError} />}
//{ error: errors.name }

class Tab1 extends Component {
  static defaultProps = {
    companyName: "",
    companyNumber: "",
    companyAddress: ""
  };
  state = {
    companyNameError: false,
    companyNumberError: false,
    companyAddressError: false
  };
  updateActivities = ({ name, value }) => {
    this.props.updateInput({
      name: name,
      value: {
        CUSTOM: value
      }
    });
  };

  submit = () => {
    if (!this.props.tab1AutoFillDone) {
      this.props.moveToNextTab();
      return;
    }

    const { companyName, companyAddress } = this.props;

    const companyNameError = companyName === "" ? true : false;
    const companyNumberError = false;
    const companyAddressError = companyAddress === "" ? true : false;

    this.setState({
      companyNameError,
      companyNumberError,
      companyAddressError
    });

    if (companyNameError || companyNumberError || companyAddressError) {
      return;
    }

    this.props.moveToNextTab();
  };
  updateInput = data => {
    if (data.name === "companyNumber") {
      this.setState({
        companyNumberError: false
      });
    } else {
      this.setState({
        [data.name + "Error"]: data.value !== "" ? false : true
      });
    }

    this.props.updateInput(data);
  };
  render() {
    const props = this.props;
    const state = this.state;
    //Prep activities
    let companyActivities = "";
    if (props.companyDescription !== null) {
      const activitiesCount = Object.keys(props.companyDescription).length;
      //object keys into map and loop over map
      Object.keys(props.companyDescription).forEach((e, index) => {
        companyActivities = companyActivities + props.companyDescription[e];
        if (index > activitiesCount) {
          companyActivities = companyActivities + ",";
        }
      });
    }

    return (
      <div className="form_steps test_tab1">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            <TabNavigation />
            <div className="form_content">
              <div className="fields_container">
                <div
                  className={classNames("field_block field_block--fill", {
                    error: state.companyNameError
                  })}
                >
                  <label>{props.domain.Strings.tab1CompanyLabel}</label>
                  <Input
                    onChange={this.updateInput}
                    value={props.companyName}
                    name="companyName"
                    className="test_tab1CompanyNameInput"
                    placeholder={props.domain.Strings.tab1CompanyPlaceholder}
                  />
                  {state.companyNameError && (
                    <InputError label={props.domain.Strings.tab1CompanyError} />
                  )}
                </div>
                {props.tab1ShowExtraFields && (
                  <React.Fragment>
                    <div
                      className={classNames("field_block field_block--fill", {
                        error: state.companyNumberError
                      })}
                    >
                      <label>{props.domain.Strings.tab1RegNumberLabel}</label>
                      <Input
                        onChange={this.updateInput}
                        name="companyNumber"
                        value={props.companyNumber}
                        placeholder={
                          props.domain.Strings.tab1RegNumberPlaceholder
                        }
                      />
                      {state.companyNumberError && (
                        <InputError
                          label={props.domain.Strings.tab1RegNumberError}
                        />
                      )}
                    </div>
                    <div
                      className={classNames("field_block field_block--fill", {
                        error: state.companyAddressError
                      })}
                    >
                      <label>{props.domain.Strings.tab1AddressLabel}</label>
                      <TextArea
                        onChange={this.updateInput}
                        value={props.companyAddress}
                        name="companyAddress"
                        placeholder={
                          props.domain.Strings.tab1AddressPlaceholder
                        }
                      />
                      {state.companyAddressError && (
                        <InputError
                          label={props.domain.Strings.tab1AddressError}
                        />
                      )}
                    </div>
                    <div className="field_block">
                      <label>{props.domain.Strings.tab1DescLabel}</label>
                      <Input
                        onChange={this.updateActivities}
                        value={companyActivities}
                        name="companyDescription"
                        placeholder={props.domain.Strings.tab1DescPlaceholder}
                      />
                    </div>
                  </React.Fragment>
                )}
                <NextStepButton
                  text={props.tab1TryAgain ? props.domain.Strings.tab1NextBtnTryAgain : props.domain.Strings.tab1NextBtn}
                  onClick={this.submit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateInput: ({ name, value }) =>
      dispatch({ type: UPDATE_INPUT, name, value }),
    moveToNextTab: () =>
      dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab1);
